import React, { FC } from 'react'

const ChatLauncherIconHeader: FC<{
    className?: string
}> = ({ className = '' }) => (
    <svg
        width="32"
        height="30"
        viewBox="0 0 32 30"
        className={className}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g clip-path="url(#clip0_69_2)">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M5.3874 29.2832C5.10136 29.2557 4.81783 29.2173 4.53805 29.1681C4.11749 29.0941 3.76915 28.8052 3.62451 28.4104C3.47985 28.0155 3.56092 27.5748 3.83711 27.2547C4.47948 26.5099 4.93448 25.6077 5.13465 24.6165C5.17105 24.4363 5.0988 24.1211 4.72928 23.7677C2.10264 21.2564 0.470703 17.8481 0.470703 14.0801C0.470703 6.20985 7.52343 0 16.0001 0C24.4768 0 31.5295 6.20985 31.5295 14.0801C31.5295 21.9504 24.4768 28.1601 16.0001 28.1601C14.6731 28.1601 13.3831 28.0091 12.1507 27.7243C10.4963 28.7439 8.53851 29.3336 6.44355 29.3336C6.08752 29.3336 5.73504 29.3165 5.3874 29.2832Z"
                fill="white"
            />
            <g filter="url(#filter0_d_69_2)">
                <path
                    d="M9.82471 17.9943V21.6907H15.63C21.0875 21.6907 24.2837 18.4511 24.2837 14.0372V13.9937C24.2837 9.57993 21.1309 6.4707 15.7171 6.4707H9.82471V10.167L12.5845 10.167L15.804 10.167C18.3479 10.167 19.9787 11.602 19.9787 14.0589V14.1024C19.9787 16.5593 18.3479 17.9944 15.804 17.9944L9.82471 17.9943Z"
                    fill="url(#paint0_linear_69_2)"
                />
                <path
                    d="M9.82471 17.5595H14.0428V10.6018H9.82471V17.5595Z"
                    fill="url(#paint1_linear_69_2)"
                />
            </g>
        </g>
        <defs>
            <filter
                id="filter0_d_69_2"
                x="7.23645"
                y="6.47069"
                width="19.6355"
                height="20.3965"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dy="2.58825" />
                <feGaussianBlur stdDeviation="1.29413" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_69_2"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_69_2"
                    result="shape"
                />
            </filter>
            <linearGradient
                id="paint0_linear_69_2"
                x1="9.88243"
                y1="3.29418"
                x2="25.2683"
                y2="18.9003"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#1EF2FF" />
                <stop offset="0.51" stop-color="#7133FF" />
                <stop offset="1" stop-color="#CD21FF" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_69_2"
                x1="9.88243"
                y1="3.29418"
                x2="25.2683"
                y2="18.9003"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#1EF2FF" />
                <stop offset="0.51" stop-color="#7133FF" />
                <stop offset="1" stop-color="#CD21FF" />
            </linearGradient>
            <clipPath id="clip0_69_2">
                <rect width="32" height="29.3333" fill="white" />
            </clipPath>
        </defs>
    </svg>
)
export default ChatLauncherIconHeader
